import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stateInput", "countryInput"]
  static values = {
    countryGroups: Object,
  }

  connect() {
    this.toggleStateInput()
  }

  toggleStateInput() {
    const showStateInput =
      this.countryGroupsValue[this.countryInputTarget.value].includes("CH")

    this.stateInputTarget.classList.toggle("hidden", !showStateInput)
  }
}
